import { doc, getDoc, getFirestore } from "@firebase/firestore"
import { log } from "../../../../utils"

class Dashboard {
    constructor(app, user, dashboardApp) {
        this.app = app
        this.user = user
        this.dashboardApp = dashboardApp
    }

    async init(activeSubCallback, inactiveSubCallback) {
        const firestore = getFirestore(this.app)

        getDoc(doc(firestore, `dashboard/${this.user.uid}`)).then((dashboardAppSubscription) => {
            if (dashboardAppSubscription.exists()) {
                const operatorData = dashboardAppSubscription.data()

                const appHandler = (mDashboardApp) => {
                    if (mDashboardApp != undefined) {
                        if (mDashboardApp.active) {
                            const expires = mDashboardApp.expires.toDate()
                            
                            const now = new Date()

                            if (now.getTime() < expires.getTime()) {
                                activeSubCallback(operatorData)
                            } else { inactiveSubCallback() }
                        } else { inactiveSubCallback() }
                    } else { inactiveSubCallback() }
                }


                if (this.dashboardApp === "ride") {
                    appHandler(operatorData)
                } else {
                    appHandler(operatorData[this.dashboardApp])
                }
            } else {
                console.log(0);
                // inactiveSubCallback()
            }
        }).catch((e) => {
            log(e.message)
        })
    }
}

export { Dashboard }